<template>
  <div>
    <loader :isLoading="isRequestInProgress"/>
    <CreateNavBar />
    <div class="container">
    <CreateTitle :title="page_title"/>

    <div class="create">
      <div class="row">
        <div class="col-sm">
          <CreatePageImage :src="image.url" :alt="image.alt" :width="image.width" />
        </div>

        <div class="col-sm" v-show="!success">
          <form @submit.prevent="submit" novalidate>
            <InputComponent
              type="email"
              for="email"
              label_text="Email Address"
              attribute="Email Address"
              placeholder="you@awesome.com"
              v-model="form.email_address"
              :v="$v.form.email_address" />

            <small id="input-help" class="form-text text-muted">
              We'll never share your email with anyone else.
            </small>

            <InputComponent
              type="text"
              for="firstname"
              label_text="First Name"
              attribute="First Name"
              placeholder="Juan"
              v-model="form.firstname"
              :v="$v.form.firstname" />

            <InputComponent
              type="text"
              for="lastname"
              label_text="Last Name"
              attribute="Last Name"
              placeholder="Dela Cruz"
              v-model="form.lastname"
              :v="$v.form.lastname" />

            <InputComponent
              type="text"
              for="company"
              label_text="Company Name"
              attribute="Company"
              placeholder="Awesome Company"
              v-model="form.company"
              :v="$v.form.company" />

            <InputComponent
              type="text"
              for="mobile_number"
              label_text="Mobile Number"
              attribute="Mobile Number"
              placeholder="0922XXXXXXX"
              v-model="form.mobilenumber"
              :v="$v.form.mobilenumber" />
            <small id="input-help" class="form-text text-muted">
              Add your mobile number in this format: 0922XXXXXXX
            </small>

    	      <div class="text-center">
    	        <button type="submit" class="btn btn-primary">Submit</button>
    	      </div>
      	  </form>
          <div class="summary text-center" v-if="$v.form.$error">
            Form has some errors, please complete your details. Thanks!
          </div>
        </div>

        <div class="col-sm" v-show="success">
          <div class="summary text-center" style="padding-top: 25px;">
          	<h1>Awesome! We'll get back to you shortly. Thank you for your interest.</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>

</template>

<script>
import { required, email, numeric } from 'vuelidate/lib/validators'
import { isCorrectMobileNumberFormat } from '@/form-validators'

import CreateNavBar from '@/components/common/CreateNavBar'
import CreateTitle from '@/components/common/CreateTitle'
import CreatePageImage from '@/components/common/CreatePageImage'
import Loader from '@/components/common/Loader'

import InputComponent from '@/components/form/InputComponent'

import { ASSET_REQUEST_DEMO } from '@/api/constants/ImageAssets'
import { APIService } from '@/api/APIService'

const api = new APIService()

export default {
  components: {
    CreateNavBar,
    CreateTitle,
    CreatePageImage,
    InputComponent,
    Loader
  },
  data() {
    return {
      page_title: 'Request Invite',
      image: ASSET_REQUEST_DEMO,
      form: {
        email_address: '',
        firstname: '',
        lastname: '',
        company: '',
        mobilenumber: '',
      },
      success: false,
      error: true,
      isRequestInProgress: false
    }
  },
  validations: {
    form: {
      email_address: { required, email },
      firstname: { required },
      lastname: { required },
      company: { required },
      mobilenumber: { required, numeric, isCorrectMobileNumberFormat }
    }
  },
  methods: {
    submit() {
      this.$v.form.$touch()

      if (this.$v.form.$pending || this.$v.form.$error) return

      // Add submitted code here
      const fields = {
        Email: this.form.email_address,
        Firstname: this.form.firstname,
        Lastname: this.form.lastname,
        Company: this.form.company,
        MobileNumber: this.form.mobilenumber
      }

      this.isRequestInProgress = true
      api.postRequestDemo(fields)
      .then((data) => {
        this.isRequestInProgress = false
        this.success = true
        this.error = false
        this.form = {}
      }).catch((err) => {
        this.isRequestInProgress = false
        this.success = false
        this.error = `Something went wrong, please try again!\n${err}`
      })

      this.success = true
      this.isRequestInProgress = false
    }
  }
}

</script>

<style>
@import '../assets/styles/form-style-1.css';
</style>



// WEBPACK FOOTER //
// src/containers/RequestDemo.vue